import { forEach, isEmpty, get } from 'lodash';
import Avatar, { List, Spin } from 'antd';
import React, { useState } from 'react';
import 'antd/dist/antd.css';
import { unix, now } from 'moment';
import { MenuOutlined } from '@ant-design/icons';
import { Link, useHistory } from 'react-router-dom';
import consts, { PREFIX_FRONT_URL } from '../../../consts';

export default (props) => {
  const [lang, setLang] = useState(localStorage.getItem('LANG') || consts.VI);

  window.addEventListener('changeLocalization', (e) => {
    setLang(localStorage.getItem('LANG') || consts.VI);
  });

  // const notifiesToday = [];
  // const notifiesBefore = [];
  // const currentTime = now() / 1000;
  // forEach(props.notifies, (notify) => {
  //   if (notify.created_at > currentTime - 86400) {
  //     notifiesToday.push(notify);
  //   } else {
  //     notifiesBefore.push(notify);
  //   }
  // });

  const onCheck = (item) => {
    window.h.push(item.link);
    props.checkedUserNotifications(item.created_at);
  };

  const onCheckAllNotification = () => {
    props.toggleViewAllNotify()
  }

  return (
    <>
      <div className="drawer-top-notify tt-none">
        <div className="common-header notification-1">
          <div className="d-flex align-items fontW-700">
            <span className="total-count">
              {props.totalCountAll ?? ""}
            </span>
            <span>{window.$t('common.notification')}</span>
            <span title={window.$t(('notify_page.mark_all_as_read'))} className="icon-tabsbar ml-small" onClick={onCheckAllNotification}/>
          </div>
          <div>
            <Link className="notification-1-view-all" to={`${PREFIX_FRONT_URL}/${window.c.routes.NOTIFICATION}`}>{window.$t('common.view_all')}</Link>
          </div>
        </div>
        <div className="list-notifications">
          <List
            itemLayout="horizontal"
            dataSource={props.notifies}
            loading={props.loading}
            renderItem={(item) => (
              <List.Item className="text-white pointer" onClick={() => onCheck(item)}>
                <List.Item.Meta
                  // title={item.map_title[lang]}
                  description={(
                    <div className="d-flex w.100 align-items">
                      <div style={{ width: '17%' }} className="d-flex align-items">
                        <div className={`notification-images ${item.is_new ? 'notification-images-true' : 'notification-images-false'}`} />
                        <div
                          style={{
                            backgroundImage: `url(${get(props.coins[item.coin || item.currency], 'icon_image', '')})`,
                            height: '20px',
                            width: '20px',
                            backgroundSize: 'contain',

                            display: 'block',
                            backgroundRepeat: 'no-repeat',
                          }}
                          alt={item.coin}
                        />
                      </div>
                      <div style={{ width: '50%', paddingRight: 18 }}>
                        <div className="ellipsis text-white bold">
                          {item.map_title[lang]}
                        </div>
                        <div className="ellipsis text-grey">
                          {item.map_content[lang]}
                        </div>
                      </div>
                      <div className="ellipsis text-white item-created-at text-center">
                        {unix(item.created_at).fromNow()}
                      </div>
                    </div>
                  )}
                />
              </List.Item>
            )}
          />
        </div>

        {/* {!isEmpty(notifiesBefore) && (
          <div>
            <div
              className="bold"
              style={{
                fontSize: '12px',
                padding: '18px 0 5px 10px',
              }}
            >
              {window.$t('common.previous')}
            </div>
            <List
              itemLayout="horizontal"
              dataSource={notifiesBefore}
              renderItem={(item) => (
                <List.Item className="text-white pointer" onClick={() => window.h.push(item.link)}>
                  <List.Item.Meta
                    // title={item.map_title[lang]}
                    description={(
                      <div className="d-flex w.100 align-items">
                        <div className="notification-images" />
                        <div
                          style={{
                            backgroundImage: `url(${get(props.coins[item.coin || item.currency], 'icon_image', '')})`,
                            height: '20px',
                            width: '20px',
                            backgroundSize: 'contain',
                            marginRight: '20px',
                            display: 'block',
                            backgroundRepeat: 'no-repeat',
                          }}
                          alt={item.coin}
                        />
                        <div style={{ width: '50%' }}>
                          <div className="ellipsis text-white bold">
                            {item.map_title[lang]}
                          </div>
                          <div className="ellipsis text-grey">
                            {item.map_content[lang]}
                          </div>
                        </div>
                        <div className="ellipsis text-white pl-small item-created-at text-center">
                          {unix(item.created_at).fromNow()}
                        </div>
                      </div>
                    )}
                  />
                </List.Item>
              )}
            />
          </div>
        )} */}

        {/* <Link to={'#'} style={{paddingLeft: 10, color: 'white', fontWeight: 'bold', fontSize: '12px'}}> */}
        {/*	{window.$t('View more')} >> */}
        {/* </Link> */}
      </div>
    </>
  );
};
